module.exports = __webpack_public_path__ + "static/media/caigoujihua1.ec304659.png";